import React from 'react';
import { Link } from 'react-router-dom';
import sidebarMenusData from './customerSidebarMenusData.jsx';
const CustomerSidebar = () => {
  return (
    <aside className="db-sidebar">
      <div className="db-sidebar-header">
        <button className="fa-solid fa-xmark xmark-btn close-db-menu"></button>
      </div>
      {sidebarMenusData.length > 0 && (
        <nav className="db-sidebar-nav">
          <ul className="db-sidebar-nav-list">
            {sidebarMenusData.map((menu) => (
              <React.Fragment key={menu.id}>
                {menu.url === '#' ? (
                  <li className="db-sidebar-nav-item">
                    <a href="javascript:void(0);" className="db-sidebar-nav-title">
                      {menu.text}
                    </a>
                  </li>
                ) : (
                  <li className="db-sidebar-nav-item">
                    <Link to={`/customer/${menu.url}`} className="db-sidebar-nav-menu">
                      <i className={`text-sm ${menu.icon}`}></i>
                      <span className="text-base flex-auto">{menu.text}</span>
                    </Link>
                  </li>
                )}
                {menu.children &&
                  menu.children.map((child) => (
                    <li className="db-sidebar-nav-item" key={child.id}>
                      <Link to={`/customer/${child.url}`} className="db-sidebar-nav-menu">
                        <i className={`text-sm ${child.icon}`}></i>
                        <span className="text-base flex-auto">{child.text}</span>
                      </Link>
                    </li>
                  ))}
              </React.Fragment>
            ))}
          </ul>
        </nav>
      )}
    </aside>
  );
};

export default CustomerSidebar;
